<template>
  <div>
  komisionet
  
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>